import { createFileRoute } from '@tanstack/react-router';
import ApplicationEditPage from '@/components/DeveloperApplications/ApplicationEditPage';

export const Route = createFileRoute('/developers/applications/$id/edit')({
  component: ApplicationEditRoute,
});

function ApplicationEditRoute() {
  const { id } = Route.useParams();
  return <ApplicationEditPage id={id} />;
}
